// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrandingProvider } from './contexts/BrandingContext';

// Check if we're in Electron environment
const isElectron = window.electronAPI !== undefined;

if (!isElectron) {
  console.log('Running in web mode. Loading web adapter...');
  // Load web adapter for browser environment
  import('./webAdapter').then(module => {
    window.electronAPI = module.default;
    console.log('Web adapter loaded successfully');
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrandingProvider>
      <App />
    </BrandingProvider>
  </React.StrictMode>
);

// Service worker registration for PWA capabilities (optional)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then(
      (registration) => {
        console.log('ServiceWorker registration successful:', registration.scope);
      },
      (err) => {
        console.log('ServiceWorker registration failed:', err);
      }
    );
  });
}